import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { defineGlobalVersion } from '@hzero-front-ui/core';
import { pageEvents } from '../utils/event';
import intl, { defaultLocale } from '../utils/intl';
import ConfigIndex from './ConfigIndex';
import ConfigByStep from './ConfigByStep';
defineGlobalVersion(require('../../package.json'));
var pageMap = {
  'theme-config': ConfigIndex,
  'theme-config/components': ConfigByStep
}; // language: zh_CN, en_US

var ProdApp = function ProdApp(props) {
  var _useState = useState({
      path: 'theme-config',
      params: {}
    }),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  intl.changeLocale(props.lang);
  if (props.localeData && typeof props.localeData === 'object') {
    intl.loadData(_objectSpread(_objectSpread({}, defaultLocale), props.localeData));
  }
  useEffect(function () {
    pageEvents.on('push', function (path) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      setPage({
        path: path,
        params: params
      });
    });
  }, []);
  var DisplayPage = pageMap[page.path] || function () {
    return /*#__PURE__*/React.createElement("div", null, "404 Not Found");
  };
  return /*#__PURE__*/React.createElement(DisplayPage, page.params);
};
ProdApp.defaultProps = {
  lang: 'zh_CN',
  localeData: null
};
export default ProdApp;